import React, { useState, useEffect } from 'react'
import { Formik } from 'formik'
import { Wrapper, Card } from '../../_components'
import { useDispatch, useSelector } from 'react-redux'
import Theme from '../../Theme'
import { Main, SectionA, SectionB, SectionC, SectionD, SectionE, SectionF, SectionI } from './Forms'
import FormEntry from './FormEntry'
import Axios from 'axios'

const steps = [
  "General",
  "Section A",
  "Section B",
  "Section C",
  "Section D",
  "Section E",
  "Section F",
  "Section I",
  "Preview"
]

const renderContent = ( step, handleChange, handleBlur, values ) => {
  switch( step ) {
    case 0:
      return <Main 
              values={values} 
              handleChange={handleChange}
              handleBlur={handleBlur} 
              // handleSeason={handleSeason}
              // editResults={editResults}
            />
    case 1:
      return <SectionA 
              values={values} 
              handleChange={handleChange}
              handleBlur={handleBlur} 
              // editResults={editResults}
            />
    case 2:
      return <SectionB 
                values={values} 
                handleChange={handleChange}
                handleBlur={handleBlur}
              />
    case 3:
      return <SectionC 
                values={values} 
                handleChange={handleChange}
                handleBlur={handleBlur}
              />
    case 4:
      return <SectionD 
                values={values} 
                handleChange={handleChange}
                handleBlur={handleBlur}
              />
    case 5:
      return <SectionE 
                values={values} 
                handleChange={handleChange}
                handleBlur={handleBlur}
              />
    case 6:
      return <SectionF
                values={values} 
                handleChange={handleChange}
                handleBlur={handleBlur}
              />
    case 7:
      return <SectionI
                values={values} 
                handleChange={handleChange}
                handleBlur={handleBlur}
              />
    default:
      break;
  }
}


let season = localStorage.getItem( "season" )
let operation = localStorage.getItem( "operation" )

export default function Form() {
  const [ activeStep, setActiveStep ] = useState( 0 )
  const isLastStep = activeStep === ( steps.length - 1 )
  const [ loading, setLoading ] = useState( true )

  const dispatch = useDispatch()
  const state = useSelector( state => {
    return {
      title: state.application.displayModal?.title,
      flag: state.application.displayModal?.flag,
      purchaseTools: state.application.purchaseTools,
      seeds: state.application.purchaseSeeds,
      labor: state.application.labor,
      labor2: state.application.labor2,
      harvestTools: state.application.harvestTools,
      tag: state.application.displayModal?.tag,
      revenue: state.application.revenue
    }
  } )

  useEffect( () => {
    if( operation === "edit" ) {
      fetchApplicationDetails()
    }
  }, [ operation ])

  const fetchApplicationDetails = async () => {
    try {
      await Axios.get( `https://mis.nec.go.ug/api/auth/fiefoc_production` )
    } catch (error) {
      
    }
  }

  const handleSubmit  = async ( values ) => {
    if( isLastStep ) {
      try {
        const payload  = { 
          tools: state.purchaseTools,
          seeds: state.seeds,
          labor: state.labor,
          harvestTools: state.harvestTools,
          block_number: values.block_number,
          season: values.season,
          season_number: values.season === "NovApril23" ? 1 : 2,
          season_1: values.season === "NovApril23" ? "Yes" : "",
          season_2: values.season === "MaySept23" ? "Yes" : "",
          season_tag: values.season === "NovApril23" ? 1 : ( values.season === "MaySept23" ? 2 : "" ),
          plot_number: values.plot_number,
          name: values.name,
          water_fees: values.water_fees,
          harvested_rice: values.harvested_rice,
          contact: values.contact,
          farmer_code: localStorage.getItem( "selectedFarmerCode" ),
          qty_1: parseFloat( values.qty_1 ),
          rate_1: parseFloat( values.rate_1 ),
          amount_1: parseFloat( values.qty_1 ) * parseFloat( values.rate_1 ),
          qty_2: parseFloat( values.qty_2 ),
          rate_2: parseFloat( values.rate_2 ),
          amount_2: parseFloat( values.qty_2 ) * parseFloat( values.rate_2 )
        }

        const response = await Axios.post(  `https://mis.nec.go.ug/api/auth/fiefoc_production`, payload )
        
        if( response.data ) {
          alert( response.data.message )
          localStorage.setItem( "name", "production" )
          window.location.reload()
        }

      } catch ( error ) {
        alert( "Server could not add production record. server error occured." )
      }
    } 
    else {
      setActiveStep( activeStep + 1 )
    }
  } 

  return (
    <Wrapper>
      <div className="grid grid-cols-1 items-center">
        <Card icon={Theme.PlusIcon} title={`${localStorage.getItem( "tag" ) === "edit" ? `Edit` : `Add` } Farmer Production Data For ${localStorage.getItem( "selectedFarmerName" )} - ${localStorage.getItem( "selectedFarmerCode" )} Farmer`}>
          <div className="w-full overflow-x-hidden">
            <div>
              {/* <StepperItem label="Section A" active={activeStep} /> */}
            </div>
          </div>
          { loading ? 
          ( <Formik 
            initialValues={{
              season: "",
              name: localStorage.getItem( "selectedFarmerName" ) || "",
              block_number: localStorage.getItem( "selectedBlockId" ) || "",

              ffsg_number: localStorage.getItem( "selectedFFSCode" ) || "",
              plot_number: localStorage.getItem( "selectedPlotNo" ) || "",
              farmer_code: localStorage.getItem( "selectedPlotNo" ) || "",

              contact: localStorage.getItem( "selectedPhoneNumber" ) || "",
              water_fees: "",
              harvested_rice: "",

              qty_1: "",
              rate_1: "",
              amount_1: "",

              qty_2: "",
              rate_2: "",
              amount_2: ""
          }} 
          // validationSchema={validationSchema}
          onSubmit={handleSubmit}>
          { ( { values, handleBlur, handleChange, handleSubmit } ) => {
            return (
              <form onSubmit={handleSubmit}>
                  {renderContent( activeStep, handleChange, handleBlur, values )}
                  {activeStep > 0 && (
                    <button onClick={() => setActiveStep( activeStep - 1 )} type="button" className="bg-blue-700 px-5 py-2 mx-2 text-white text-sm rounded">
                      {`Back`}
                    </button>
                  )}
                  <button type="submit" className="bg-green-700 px-5 py-2 mx-2 text-white text-sm rounded">
                    {isLastStep ? `Submit` : `Proceed to Next`}
                  </button>
              </form>
            )
        } }
          </Formik> ): (
            <div className="text-xs text-center">
              {`Loading data`}
            </div>
          ) }
        </Card>
      </div>
      <FormEntry />
    </Wrapper>
  )
}